import { z } from 'zod';
/** `teams.type`: the International / Domestic tabs (A-08, M-06). */
export const TEAM_TYPES = ['INTERNATIONAL', 'DOMESTIC'];
export const TeamTypeSchema = z.enum(TEAM_TYPES);
/** `players.role`. */
export const PLAYER_ROLES = ['BATTER', 'BOWLER', 'ALL_ROUNDER', 'WICKET_KEEPER'];
export const PlayerRoleSchema = z.enum(PLAYER_ROLES);
/** `players.captaincy` (STATS-02): at most one captain and one vice-captain per team. */
export const PLAYER_CAPTAINCIES = ['NONE', 'CAPTAIN', 'VICE_CAPTAIN'];
export const PlayerCaptaincySchema = z.enum(PLAYER_CAPTAINCIES);
/**
 * The app's legacy format chips and `GET /v1/app/teams/{id}/stats?format` (unchanged for the
 * mobile app). Stored stats use `STATS_FORMATS`; `T20` here is the domestic T20 (STATS-01).
 */
export const CRICKET_FORMATS = ['T20', 'ODI', 'TEST'];
export const CricketFormatSchema = z.enum(CRICKET_FORMATS);
/**
 * `player_stats.format` (STATS-01): the six formats of the legacy player sheet. T20I = T20
 * internationals, T20 = domestic T20s, LIST_A and FC = domestic one-day and first-class.
 */
export const STATS_FORMATS = ['T20I', 'T20', 'ODI', 'LIST_A', 'TEST', 'FC'];
export const StatsFormatSchema = z.enum(STATS_FORMATS);
/** `player_stats.source` (Q-07). */
export const STATS_SOURCES = ['MANUAL', 'IMPORT', 'FEED'];
export const StatsSourceSchema = z.enum(STATS_SOURCES);
/** `player_imports.status` (FEAT-01 bulk player upload): upload, check, preview, import. */
export const PLAYER_IMPORT_STATUSES = [
    'AWAITING_UPLOAD',
    'VALIDATING',
    'PREVIEW_READY',
    'REJECTED',
    'APPLYING',
    'APPLIED',
    'FAILED',
];
export const PlayerImportStatusSchema = z.enum(PLAYER_IMPORT_STATUSES);
/** What the import does with one sheet row. */
export const PLAYER_IMPORT_ROW_ACTIONS = ['CREATE', 'UPDATE', 'ERROR'];
export const PlayerImportRowActionSchema = z.enum(PLAYER_IMPORT_ROW_ACTIONS);
/** How a row found its photo in the images zip (or why it has none). */
export const PLAYER_IMAGE_MATCHES = [
    'MATCHED_IMAGE',
    'MATCHED_ICON',
    'MATCHED_NAME',
    'MISSING',
    'INVALID',
    'NO_ZIP',
];
export const PlayerImageMatchSchema = z.enum(PLAYER_IMAGE_MATCHES);
/** The players sheet's file type. */
export const PLAYER_IMPORT_FILE_TYPES = ['XLSX', 'CSV'];
export const PlayerImportFileTypeSchema = z.enum(PLAYER_IMPORT_FILE_TYPES);
/**
 * What a player import may do (STATS-01, STATS-02): PLAYERS creates or updates players (profile and
 * stats; the team header's Bulk upload); UPDATE only updates the profile and stats of players
 * already in the team and never touches photos (the Stats tab's "Update players & stats").
 */
export const PLAYER_IMPORT_MODES = ['PLAYERS', 'UPDATE'];
export const PlayerImportModeSchema = z.enum(PLAYER_IMPORT_MODES);
/** Downloads offered next to the bulk upload: the two templates and a ready-to-try sample. */
export const PLAYER_IMPORT_TEMPLATE_TYPES = ['XLSX', 'CSV', 'SAMPLE'];
export const PlayerImportTemplateTypeSchema = z.enum(PLAYER_IMPORT_TEMPLATE_TYPES);
//# sourceMappingURL=teams.js.map